import styles from './styles.module.scss';
import banner from '../../images/oficinas-main-banner.png';
import OficinasTitle from '../../images/oficinas-page-title.svg';

function OficinasMainBanner() {
  return (
    <div className={styles.bannerContainer}>
      <img
        src={OficinasTitle}
        alt="oficinas titule"
        className={styles.titleImage}
      />
      <img src={banner} alt="banner oficinas" className={styles.bannerImage} />
      <div className={styles.triangle} />
    </div>
  );
}

export default OficinasMainBanner;
